import React, { Fragment, FC, useContext, useEffect, useState } from "react";
import { Dialog, Transition } from '@headlessui/react';

import { Link } from "react-router-dom";
import Badge from "./Badge";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { PhoneInput } from "react-international-phone";

import Button from "components_common/Button/Button";

import { ArrowSmallLeftIcon, PhotoIcon } from "@heroicons/react/24/outline";
import DaumPostcode from 'react-daum-postcode';
import { requestAPI } from "utils/api";
import PictureUpload from "./PictureUpload";


const ReservationViewInfo = ({
	idx,
	productId,
	data
}: any) => {

	/*
		면허 2종 소형 소지자 
			Yes / No
		경력
			1년 미만 / 1년 이상 3년 미만 / 3년 이상 5년 미만 / 5년 이상 10년 미만 / 10년 이상
		장거리 주행(1,000km 이상) 경험이 있으신가요?
			Yes / No
		평소 앓고 있는 지병이 있나요?
			있음 (질병명 작성)		
			없음
		이름
		생년월일
		연락처
		방문경로
			딜러 / 인터넷 / 카페 / 블로그 / 인스타그램 / 페이스북 / 동호회 / 지인소개 / 기타
		
		투어방법
			라이딩 / 텐더
	*/

	//const familyName = ;

	// const [familyName, setFamilyName] = useState ((data.familyName===null)? "" : data.familyName);
	// const [givenName, setGivenName] = useState ((data.givenName===null)? "" : data.givenName);
	// const [birthDate, setBirthDate] = useState <any> ((data.birthdate===null)? null : formatKoreanDate(data.birthdate).date);
	// const [residence, setResidence] = useState <any> ((data.residence===null)? "" : data.residence);

	const style = {
		height: '470px',
		display: 'block'
	};

	const [ open, setOpen ] = useState(false);
	
	//const [ inputDetailAddressValue, setInputDetailAddressValue ] = useState('');
	//const [ inputZipCodeValue, setInputZipCodeValue ] = useState('');
	//const [textSub, setTextSub] = useState('');

	const textUpdateRequired = "업데이트 필요";
	const textSetting = "설정됨";

	
	const [ requestDone, setRequestDone ] = useState (false);
	const name = (data.familyName === null)
					? textUpdateRequired
					: (data.givenName === null)
						? textUpdateRequired 
						: `${data.familyName}${data.givenName}`;
	
	const address = (data.residence === null)
		? textUpdateRequired
		: `${data.residence.main} ${data.residence.detail}`;
	
	const phoneNumber = (data.phoneNumber === null)
		? textUpdateRequired
		: data.phoneNumberlast4;

	const passportUrl = (data.passportUrl === null)
		? textUpdateRequired
		: "비공개 보관중";

	const lincenseUrl = (data.licenseUrl === null)
	? textUpdateRequired
	: "비공개 보관중";


	const etcInfoGet = () => {

		let isSetup = true;

		if (data.etc.tourMethod === null || data.etc.tourMethod === "0") {
			isSetup = false;
		} else if (data.etc.disease === null || data.etc.disease === "0") {
			isSetup = false;
		} else if (data.etc.mileage === null || data.etc.mileage === "0") {
			isSetup = false;
		} else if (data.etc.drivingExperience === null || data.etc.drivingExperience === "0") {
			isSetup = false;
		}
		
		return isSetup;
	};

	const etc = (etcInfoGet() === false)
		? textUpdateRequired
		: "투어방법 설정됨";
	
	

	//etcInfoGet();

	const [ birthDate, setBirthDate ] = useState <any> ((data.birthdate === null)? textUpdateRequired : formatKoreanDate(data.birthdate).date);
	//const [ residence, setResidence ] = useState <any> ((data.residence === null)? {main:"", detail:"", zipcode: ""} : data.residence);
	//const [ residencetext, setResidenceText ] = useState <any> ((data.residence === null)? {main:"", detail:"", zipcode: ""} : data.residence);
	//const [ phone, setPhone ] = useState('');
	//const [ countryCallingNumber, setCountryCallingNumber ] = useState('');
	// const [ isDisease, setIsDisease ] = useState <any> (
	// 	(data.isDisease === null)
	// 	? "0" 
	// 	: (data.isDisease === "1")
	// 		? "1" 
	// 		: "2"
	// );
	
	


	const [uploadedInfo, setUploadedInfo] = useState <any> ({});

	

	function formatKoreanDate(dateString: string) {
		const date = new Date(dateString);
		
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2);
		const day = ('0' + date.getDate()).slice(-2);
		
		let hours = date.getHours();
		const minutes = ('0' + date.getMinutes()).slice(-2);
		const seconds = ('0' + date.getSeconds()).slice(-2);
	
		const period = hours >= 12 ? '오후' : '오전';
		hours = hours % 12 || 12; // 0 => 12
	
		const formattedDate = `${year}-${month}-${day}`;
		const formattedTime = `${period} ${hours}:${minutes}:${seconds}`;
	
		return {
			date: formattedDate,
			time: formattedTime
		};
	}

	
	const handleSave = () => {
		

		// const values = {
		// 	familyName,
		// 	givenName,
		// 	residence,
		// 	birthDate,
		// 	phone,
		// 	tourMethod,
		// 	isLicense,
		// 	isDisease,
		// 	drivingExperience,
		// 	mileage,
		// 	countryCallingNumber
		// };

		// setRequestDone(true);

		// //console.log(birthDate);
		// console.log(/^\s*$/.test(residence.main.trim()))
		// console.log(/^\s*$/.test(residence.detail.trim()))
		// console.log(residence.main);
		// console.log(residence.detail);
		// console.log(birthDate);
		// console.log(phone);
		// console.log(tourMethod);
		// console.log(isLicense);
		// console.log(drivingExperience);
		// console.log(mileage);
		// console.log(countryCallingNumber);
		// console.log(`여권 ${passportUrl} ${newPassportUrl}`)
		
		
		

		// let _phone = phone.replace(`+${countryCallingNumber}`, "");

		// if (/^\s*$/.test(familyName.trim()) === true || /^\s*$/.test(givenName.trim()) === true) {
		// 	console.log("이름없음");
		// 	setRequestDone(false);
		// 	return;
		// } else if (/^\s*$/.test(birthDate.trim()) === true) {
		// 	console.log("생년월일 없음");
		// 	setRequestDone(false);
		// 	return;
		// } else if (/^\s*$/.test(_phone.trim()) === true) {
		// 	console.log("전화번호 없음");
		// 	setRequestDone(false);
		// 	return;
		// } else if (/^\s*$/.test(residence.main.trim()) === true || /^\s*$/.test(residence.detail.trim()) === true) {
		// 	console.log("주소 없음");
		// 	setRequestDone(false);
		// 	return;
		// } else if (tourMethod === "0") {
		// 	console.log("투어 방법을 선택해 주세요");
		// 	setRequestDone(false);
		// 	return;
		// } else if (isLicense === "0") {
		// 	console.log("면허 소유 방법을 선택해 주세요");
		// 	setRequestDone(false);
		// 	return;
		// } else if (isDisease === "0") {
		// 	console.log("평소 앓고 있는 지병이 있는지 선택해 주세요");
		// 	setRequestDone(false);
		// 	return;
		// } else if (isLicense === "1") {
		
		

		// if (passportUrl === "" && newPassportUrl === "") {
		// 	console.log('둘다 없음');
		// } else if (passportUrl === "" && newPassportUrl !== "") {
		// 	console.log('패스포트');
		// } else if (passportUrl !== newPassportUrl) {
		// 	//변경
		// 	console.log('');
		// }

		// console.log( values );

		// setRequestDone(false);

	}




	const setFileInfo = (file: any) => {
		const { name, size: byteSize, type } = file;
		const size = (byteSize / (1024 * 1024)).toFixed(2) + 'mb';
		
		setUploadedInfo({ name, size, type }); // name, size, type 정보를 uploadedInfo에 저장
	};




	return (
		<div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-1 p-0 mt-4">
			
			<h2 className="text-[0.95rem] font-semibold flex-grow" style={{fontWeight: "600", color:"#282f33"}}>
				{name.trim() === ""? `예약자 ${idx+1}`: `예약자 (${name})` }
			</h2>

			
			{/* 이름 */}
			<div
				className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
			>	
				<div className="w-full flex justify-between ml-10">
					<div>
						<h2
							className={`nc-card-title text-[0.95rem]`}
							style={{fontWeight: "600", color:"#282f33"}}
						>
							이름
						</h2>
						<div
							className={`block mt-[2px] text-[0.9rem]`}
							style={{fontWeight: "500", color:"#586066"}}
						>
							{name === "업데이트 필요"
								? <span className={"text-red-500"}>{name}</span>
								: name
							}
						</div>
					</div>
					<Link 
						to={`/reservation/${productId}/name/${idx}`}
						className={`flex items-center mr-10 text-[0.9rem]`}
						style={{fontWeight: "500", color:"#282f33"}}
					>
						수정
					</Link>
				</div>
			</div>
			
				
			{/* 생년월일 */}
			<div
				className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
			>
				<div className="w-full flex justify-between ml-10">
					<div>
						<h2
							className={`nc-card-title text-[0.95rem]`}
							style={{fontWeight: "600", color:"#282f33"}}
						>
							생년월일
						</h2>
						<div
							className={`block mt-[2px] text-[0.9rem]`}
							style={{fontWeight: "500", color:"#586066"}}
						>
							{birthDate === "업데이트 필요"
								? <span className={"text-red-500"}>{birthDate}</span>
								: birthDate
							}
						</div>
					</div>
					<Link 
						to={`/reservation/${productId}/birthdate/${idx}`}
						className={`flex items-center mr-10 text-[0.9rem]`}
						style={{fontWeight: "500", color:"#282f33"}}
					>
						수정
					</Link>

				</div>
			</div>

			{/* 주소지 */}
			<div
				className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
			>
				<div className="w-full flex justify-between ml-10">
					<div>
						<h2
							className={`nc-card-title text-[0.95rem]`}
							style={{fontWeight: "600", color:"#282f33"}}
						>
							주소지
						</h2>
						<div
							className={`block mt-[2px] text-[0.9rem]`}
							style={{fontWeight: "500", color:"#586066"}}
						>
							{address === "업데이트 필요"
								? <span className={"text-red-500"}>{address}</span>
								: address
							}
							
						</div>
					</div>
					<Link 
						to={`/reservation/${productId}/residence/${idx}`}
						className={`flex items-center mr-10 text-[0.9rem]`}
						style={{fontWeight: "500", color:"#282f33"}}
					>
						수정
					</Link>
				</div>
			</div>

			{/* 연락처 */}
			<div
				className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
			>
				<div className="w-full flex justify-between ml-10">
					<div>
						<h2
							className={`nc-card-title text-[0.95rem]`}
							style={{fontWeight: "600", color:"#282f33"}}
						>
							연락처
						</h2>
						<div
							className={`block mt-[2px] text-[0.9rem]`}
							style={{fontWeight: "500", color:"#586066"}}
						>
							{phoneNumber === "업데이트 필요"
								? <span className={"text-red-500"}>{phoneNumber}</span>
								: phoneNumber
							}

						</div>
					</div>
					<Link 
						to={`/reservation/${productId}/phonenumber/${idx}`}
						className={`flex items-center mr-10 text-[0.9rem]`}
						style={{fontWeight: "500", color:"#282f33"}}
					>
						수정
					</Link>
				</div>
			</div>

			{/* 여권정보 */}
			<div
				className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
			>
				<div className="w-full flex justify-between ml-10">
					<div>
						<h2
							className={`nc-card-title text-[0.95rem]`}
							style={{fontWeight: "600", color:"#282f33"}}
						>
							여권정보
						</h2>
						<div
							className={`block mt-[2px] text-[0.9rem]`}
							style={{fontWeight: "500", color:"#586066"}}
						>
							{passportUrl === "업데이트 필요"
								? <span className={"text-red-500"}>{passportUrl}</span>
								: passportUrl
							}

						</div>
 					</div>
					<Link 
						to={`/reservation/${productId}/passport/${idx}`}
						className={`flex items-center mr-10 text-[0.9rem]`}
						style={{fontWeight: "500", color:"#282f33"}}
					>
						수정
					</Link>
				</div>
			</div>
		
			{/* 면허정보 */}
			<div
				className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
			>
				<div className="w-full flex justify-between ml-10">
					<div>
						<h2
							className={`nc-card-title text-[0.95rem]`}
							style={{fontWeight: "600", color:"#282f33"}}
						>
							면허정보
						</h2>
						<span
							className={`block mt-[2px] text-[0.9rem]`}
							style={{fontWeight: "500", color:"#586066"}}
						>
							{lincenseUrl === "업데이트 필요"
								? <span className={"text-red-500"}>{lincenseUrl}</span>
								: lincenseUrl
							}
						</span>
					</div>
					<Link 
						to={`/reservation/${productId}/license/${idx}`}
						className={`flex items-center mr-10 text-[0.9rem]`}
						style={{fontWeight: "500", color:"#282f33"}}
					>
						수정
					</Link>
				</div>
			</div>

			{/* 기타정보 */}
			<div
				className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
			>
				<div className="w-full flex justify-between ml-10">
					<div>
						<h2
							className={`nc-card-title text-[0.95rem]`}
							style={{fontWeight: "600", color:"#282f33"}}
						>
							기타정보
						</h2>
						<div
							className={`block mt-[2px] text-[0.9rem]`}
							style={{fontWeight: "500", color:"#586066"}}
						>
							<span
								className={`text-sm block mt-[2px] text-neutral-500 dark:text-neutral-400`}
							>
								{etc === "업데이트 필요"
									? <span className={"text-red-500"}>{etc}</span>
									: etc
								}
							</span>
						</div>
					</div>
					<Link 
						to={`/reservation/${productId}/etc/${idx}`}
						className={`flex items-center mr-10 text-[0.9rem]`}
						style={{fontWeight: "500", color:"#282f33"}}
					>
						수정
					</Link>
				</div>
			</div>

			{/* 기타 자료 */}
			<div
				className={`nc-CardCategory1 flex items-center bg-neutral-100 dark:bg-neutral-800 pt-3 pb-3`}
			>
				<div className="w-full flex justify-between ml-10">
					<div>
						<h2
							className={`nc-card-title text-[0.95rem]`}
							style={{fontWeight: "600", color:"#282f33"}}
						>
							기타 자료 업로드
						</h2>
						<span
							className={`block mt-[2px] text-[0.9rem]`}
							style={{fontWeight: "500", color:"#586066"}}
						>
							{lincenseUrl === "업데이트 필요"
								? <span className={"text-red-500"}>여권 및 면허 외 추가로 보낼 자료가 있을때 사용</span>
								: lincenseUrl
							}
						</span>
					</div>
					<Link 
						to={`/reservation/${productId}/etcfile/${idx}`}
						className={`flex items-center mr-10 text-[0.9rem]`}
						style={{fontWeight: "500", color:"#282f33"}}
					>
						수정
					</Link>
				</div>
			</div>

		</div>
	);
};

export default ReservationViewInfo;